import { getPath } from '@/router/common'

const baseUrl = {
  title: '客服中心',
  path: 'CustomerProfiles'
}

export default [
  {
    path: getPath('CustomerArrangement', baseUrl),
    name: 'CustomerArrangement',
    component: () =>
      import('@/views/customerProfiles/customerArrangement/index.vue'),
    meta: {
      title: '客户整理'
    }
  },
  {
    path: getPath('CustomerInformation', baseUrl),
    name: 'CustomerInformation',
    component: () =>
      import('@/views/customerProfiles/customerInformation/index.vue'),
    meta: {
      title: '客户资料'
    }
  },
  {
    path: getPath('DeliveryAreaSettings', baseUrl),
    name: 'DeliveryAreaSettings',
    component: () =>
      import('@/views/customerProfiles/deliveryAreaSettings/index.vue'),
    meta: {
      title: '送货区域设置'
    }
  },
  {
    path: getPath('Customer_query', baseUrl),
    name: 'Customer_query',
    component: () =>
      import('@/views/customerProfiles/customer_query/index.vue'),
    meta: {
      title: '客服查询记录'
    }
  },
  {
    path: getPath('ComplaintsAndSuggestions', baseUrl),
    name: 'ComplaintsAndSuggestions',
    component: () =>
      import('@/views/customerProfiles/complaintsAndSuggestions/index.vue'),
    meta: {
      title: '投诉与建议'
    }
  },
  {
    path: getPath('SCAdded', baseUrl),
    name: 'SCAdded',
    component: () =>
      import('@/views/customerProfiles/customerArrangement/sCAdded.vue'),
    meta: {
      title: '发货客户维护'
    }
  },
  {
    path: getPath('DeliveryAreaMap', baseUrl),
    name: 'DeliveryAreaMap',
    component: () =>
      import(
        '@/views/customerProfiles/deliveryAreaSettings/deliveryAreaMap.vue'
      ),
    meta: {
      title: '新增送货区域'
    }
  },
  {
    path: getPath('CustomerRetention', baseUrl),
    name: 'CustomerRetention',
    component: () =>
      import('@/views/customerProfiles/customerInformation/customerRetention.vue'),
    meta: {
      title: '客户整理收货方'
    }
  },
  {
    path: getPath('ShipImport', baseUrl),
    name: 'ShipImport',
    component: () =>
      import('@/views/customerProfiles/customerInformation/shipImport.vue'),
    meta: {
      title: '导入客户'
    }
  },
  {
    path: getPath('ReceiptImport', baseUrl),
    name: 'ReceiptImport',
    component: () =>
      import('@/views/customerProfiles/customerInformation/receiptImport.vue'),
    meta: {
      title: '导入客户'
    }
  },
  {
    path: getPath('FetcherPage', baseUrl),
    name: 'FetcherPage',
    component: () =>
      import('@/views/customerProfiles/customerInformation/fetcherPage.vue'),
    meta: {
      title: '提货客户维护'
    }
  },
  {
    path: getPath('NewCardCustomers', baseUrl),
    name: 'NewCardCustomers',
    component: () =>
      import('@/views/customerProfiles/customerInformation/newCardCustomers.vue'),
    meta: {
      title: '新增卡类客户'
    }
  },
  {
    path: getPath('AddNetAccount', baseUrl),
    name: 'AddNetAccount',
    component: () =>
      import('@/views/customerProfiles/customerInformation/addNetAccount.vue'),
    meta: {
      title: '网址下单账号'
    }
  },
  {
    path: getPath('EditNetAccount', baseUrl),
    name: 'EditNetAccount',
    component: () =>
      import('@/views/customerProfiles/customerInformation/editNetAccount.vue'),
    meta: {
      title: '修改网上下单账户'
    }
  },
  {
    path: getPath('SCMaintenance', baseUrl),
    name: 'SCMaintenance',
    component: () =>
      import('@/views/customerProfiles/customerInformation/sCMaintenance.vue'),
    meta: {
      title: '派车单接货客户'
    }
  },
  {
    path: getPath('CustomerRebate', baseUrl),
    name: 'CustomerProfiles_CustomerRebate',
    component: () => import(/* webpackChunkName: "CustomerProfiles_CustomerRebate" */ '@/views/customerProfiles/customerRebate/index.vue'),
    meta: {
      title: '客户返点报表'
    }
  },
  {
    path: getPath('ViewQuotation', baseUrl),
    name: 'CustomerProfiles_ViewQuotation',
    component: () => import(/* webpackChunkName: "CustomerProfiles_ViewQuotation" */ '@/views/customerProfiles/viewQuotation/index.vue'),
    meta: {
      title: '发货人文档查询'
    }
  },
  // 91322定制
  {
    path: getPath('ViewQuotation_91322', baseUrl),
    name: 'CustomerProfiles_ViewQuotation_91322',
    component: () => import(/* webpackChunkName: "CustomerProfiles_ViewQuotation_91322" */ '@/views/customerProfiles/viewQuotation_91322/index.vue'),
    meta: {
      title: '发货人文档查询'
    }
  },
  {
    path: getPath('ViewPDF', baseUrl),
    name: 'ViewPDF',
    component: () => import(/* webpackChunkName: "ViewPDF" */ '@/views/customerProfiles/viewPDF/index.vue'),
    meta: {
      title: '查看pdf'
    }
  },
  {
    path: getPath('VipTypeSet', baseUrl),
    name: 'VipTypeSet',
    component: () => import(/* webpackChunkName: "VipTypeSet" */ '@/views/customerProfiles/customerInformation/vipTypeSet.vue'),
    meta: {
      title: 'VIP类型维护'
    }
  },
  {
    path: getPath('UploadQuotation', baseUrl),
    name: 'UploadQuotation',
    component: () => import(/* webpackChunkName: "UploadQuotation" */ '@/views/customerProfiles/uploadQuotation/index.vue'),
    meta: {
      title: '添加价格文档'
    }
  },
  {
    path: getPath('ProductInfo_80727', baseUrl),
    name: 'ProductInfo_80727',
    component: () => import(/* webpackChunkName: "ProductInfo_80727" */ '@/views/customerProfiles/productInfo_80727/index.vue'),
    meta: {
      title: '常发品名信息80727'
    }
  },
  {
    path: getPath('songHuoDateDialog', baseUrl),
    name: 'songHuoDateDialog',
    component: () => import(/* webpackChunkName: "songHuoDateDialog" */ '@/views/customerProfiles/songHuoDateDialog/index.vue'),
    meta: {
      title: '送货时间窗'
    }
  },
  {
    path: getPath('ImportProductPage_80727', baseUrl),
    name: 'ImportProductPage_80727',
    component: () => import(/* webpackChunkName: "ImportProductPage_80727" */ '@/views/customerProfiles/importProductPage_80727/index.vue'),
    meta: {
      title: '导入常发品名信息'
    }
  },
  {
    path: getPath('Customer_payment', baseUrl),
    name: 'Customer_payment',
    component: () =>
      import('@/views/customerProfiles/customer_payment/index.vue'),
    meta: {
      title: '客服付款方式'
    }
  },
  {
    path: getPath('CustomerImportRecord', baseUrl),
    name: 'CustomerImportRecord',
    component: () =>
      import('@/views/customerProfiles/customer_payment/importRecord.vue'),
    meta: {
      title: '客户付款方式导入记录'
    }
  },
  {
    path: getPath('CustomerImportStart', baseUrl),
    name: 'CustomerImportStart',
    component: () =>
      import('@/views/customerProfiles/customer_payment/importStart.vue'),
    meta: {
      title: '导入数据'
    }
  },
  {
    path: getPath('CustomerImportDetails', baseUrl),
    name: 'CustomerImportDetails',
    component: () =>
      import('@/views/customerProfiles/customer_payment/importDetails.vue'),
    meta: {
      title: '导入数据详情'
    }
  },
  {
    path: getPath('Cargo_tracking', baseUrl),
    name: 'Cargo_tracking',
    component: () =>
      import('@/views/customerProfiles/Cargo_tracking/index.vue'),
    meta: {
      title: '货物跟踪表'
    }
  },
  {
    path: getPath('TimeLimitSetting', baseUrl),
    name: 'TimeLimitSetting',
    component: () =>
      import('@/views/customerProfiles/Cargo_tracking/timeLimitSettingDialog.vue'),
    meta: {
      title: '时效配置'
    }
  }
]
